<template>
  <div class="saleManage">
    <!-- 时间选择部分 -->
    <div class="dealTime">
      <van-tabs
        type="card"
        color="#31b158"
        title-active-color="#fff"
        title-inactive-color
        @click="switchStatus"
      >
        <van-tab title="今日" name="0"></van-tab>
        <van-tab title="本周" name="1"></van-tab>
        <van-tab title="本月" name="2"></van-tab>
        <van-tab title="自定义" name="3"></van-tab>
      </van-tabs>
      <div class="select_time">
        <div class="search-bar">
          <span class="search-date" v-if="isLook==false">
            {{listQuery.s_time}} 至 {{listQuery.e_time}}
            <!-- <van-icon name="arrow-down" style="margin-left:0.1rem"/> -->
          </span>
          <span
            class="search-date"
            @click="showCalendar=true"
            style="border: 0.01rem solid #cccccc"
            v-if="isLook==true"
          >
            {{listQuery.s_time}} 至 {{listQuery.e_time}}
            <van-icon name="arrow-down" style="margin-left:0.1rem" />
          </span>
          <van-button
            type="default"
            round
            size="large"
            style="margin-left:0.2rem,background:#31B158,color:#fff"
            @click="resetTime"
          >重置</van-button>
        </div>
      </div>
    </div>
    <!-- 总的销售情况 -->
    <div class="allSales">
      <div class="pTop">
        <div>销售额({{paid_count}}单)</div>
        <div>
          <span>￥</span>
          <span>{{paid_amount}}</span>
        </div>
        <div>
          <span v-if="discount<=0">订单优惠：</span>
          <span v-if="discount>0">订单多收：</span>
          <span>￥{{Math.abs(discount)}}</span>
        </div>
      </div>
      <div class="pBottom">
        <div>
          <div>
            <span>￥</span>
            <span>{{xs_real}}</span>
          </div>
          <div>实收</div>
        </div>
        <div></div>
        <div>
          <div>
            <span>￥</span>
            <span>{{repayment_sum}}</span>
          </div>
          <div>赊欠</div>
        </div>
      </div>
      <!-- <div class="allAmount">
        <span class="allAmount_t">销售额({{paid_count}}单)</span>
        <span class="allAmount_n">￥{{paid_amount}}</span>
      </div>
      <div class="realAmount">
        <span class="realAmount_t">实收额</span>
        <span class="realAmount_">￥{{xs_real}}</span>
      </div>
      <div class="creditAmount">
        <span class="creditAmount-t">赊欠额</span>
        <span class="creditAmount-n">￥{{repayment_sum}}</span>
      </div>
      <div class="orderDiscount">
        <span class="orderDiscount-t" v-if="discount<=0">订单优惠：</span>
        <span class="orderDiscount-t" v-if="discount>0">订单多收：</span>
        <span class="orderDiscount-n">￥{{Math.abs(discount)}}</span>
      </div>-->
    </div>
    <!-- 销售金额排行榜 -->
    <van-tabs
      v-model="active"
      color="#31b158"
      title-active-color="#31b158"
      title-inactive-color="#4D4D4D"
      @click="switchType"
    >
      <div class="seachBox">
        <div class="seach">
          <img src="../../../../assets/img/work/manage/saleList_search.png" alt />
          <input type="text" :placeholder="active==1?'请输入商品名':'请输入货主名'" v-model="searchGoodsName" />
          <div v-if="searchGoodsName" @click="clearSearchName">
            <van-icon name="cross" size="12" />
          </div>
          <button @click="getSearchGoodsName">搜索</button>
        </div>
        <!-- <div class="totalCount">
              共
              <span>{{goods.length}}</span>个商品
        </div>-->
      </div>
      <van-tab title="按产品" name="1">
        <div class="rankingList">
          <div class="tl_box">
            <div>
              <span></span>
              <span>数据明细</span>
            </div>
            <div>
              共
              <span>{{goods.length}}</span>个商品
            </div>
          </div>
          <div class="pline"></div>
          <div class="listBox">
            <div
              class="list"
              v-for="(item,i) in goods"
              :key="i"
              @click="jumpGoodsDetail(item.name,item.goods_type)"
            >
              <div class="goodsName">
                <div>{{item.name}}</div>
                <div>
                  <span>{{item.order_num}}单</span>
                  <van-icon name="arrow" v-if="item.goods_type!=2" />
                </div>
              </div>
              <div class="listData">
                <div class="sales">
                  <!-- 销量 -->
                  <div>
                    <span v-if="item.num>0 && item.num_unit==1">{{Number(item.num).toFixed(2)}}件</span>
                    <span v-if="item.num>0 && item.num_unit==2">{{Number(item.num).toFixed(2)}}包</span>
                    <span v-if="item.num>0 && item.num_unit==3">{{Number(item.num).toFixed(2)}}袋</span>
                    <span v-if="item.num>0 && item.num_unit==4">{{Number(item.num).toFixed(2)}}盒</span>
                    <span v-if="item.num>0 && item.num_unit==5">{{Number(item.num).toFixed(2)}}瓶</span>
                    <span v-if="item.num>0 && item.num_unit==6">{{Number(item.num).toFixed(2)}}箱</span>
                    <span v-if="item.num>0 && item.num_unit==7">{{Number(item.num).toFixed(2)}}罐</span>
                    <span v-if="item.weight>0">{{Number(item.weight)}}公斤</span>
                  </div>
                  <div>销量</div>
                </div>
                <div>
                  <!-- 均价 -->
                  <div>
                    <!-- 多少每件 -->
                    <span v-if="item.num>0">
                      <span>{{(Number(item.payment)/Number(item.num).toFixed(2)).toFixed(2)}}元</span>
                      <span v-if="item.num_unit==1">/件</span>
                      <span v-if="item.num_unit==2">/包</span>
                      <span v-if="item.num_unit==3">/袋</span>
                      <span v-if="item.num_unit==4">/盒</span>
                      <span v-if="item.num_unit==5">/瓶</span>
                      <span v-if="item.num_unit==6">/箱</span>
                      <span v-if="item.num_unit==7">/罐</span>
                    </span>
                    <!-- 多少每公斤 -->
                    <span
                      v-if="item.weight"
                    >{{(Number(item.payment)/Number(item.weight).toFixed(2)).toFixed(2)}}元/公斤</span>
                  </div>
                  <div>均价</div>
                </div>
                <div>
                  <div>
                    <span>{{Number(item.payment).toFixed(2)}}元</span>
                  </div>
                  <div>金额</div>
                </div>
              </div>
              <div class="line"></div>
            </div>

            <div class="empty-tip" v-show="!goods.length">{{infoTip}}</div>
          </div>
        </div>
      </van-tab>
      <!-- 按批次 -->
      <van-tab title="按批次" name="2">
        <div class="bathPart">
          <!--  -->
          <div class="tl_box">
            <div>
              <span></span>
              <span>数据明细</span>
            </div>
            <div>
              共
              <span>{{batch.length}}</span>个批次
            </div>
          </div>
          <div class="pline"></div>
          <!-- 列表 -->
          <div class="batchListBox">
            <div
              class="batchList"
              v-for="(bitem,bindex) in batch"
              :key="bindex"
              @click="jumpBatchDetail(bitem.batch_id,bitem.batch_no,bitem.goods_total_price,bitem.create_time,bitem.type,bitem.supplier_name,bitem.batch)"
            >
              <!--  -->
              <div class="part1">
                <div>
                  <span>{{bitem.supplier_name}}</span>
                  <span>{{bitem.batch_no}}</span>
                  <span
                    v-if="bitem.status==1"
                    style="color: #F76900;background: rgba(247, 105, 0, 0.2);"
                  >在售</span>
                  <span
                    v-if="bitem.status==2"
                    style="color:#FF0000;background: rgba(255, 0, 0, 0.2);"
                  >售罄</span>
                </div>
                <div>
                  <van-icon name="arrow" />
                </div>
              </div>
              <!--  -->
              <div class="part2">进货时间：{{bitem.create_time |toTime}}</div>
              <!--  -->
              <div class="part3">
                <div>
                  <div>{{bitem.purchase_payment}}</div>
                  <div>货款(元)</div>
                </div>
                <div>
                  <div>{{bitem.goods_total_price}}</div>
                  <div>销售额(元)</div>
                </div>
              </div>
            </div>
            <div v-if="batch.length==0" style="color:#999;text-align:center;padding:0.2rem;font-size:0.36rem">暂无</div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 时间选择 -->
    <van-calendar
      v-model="showCalendar"
      type="range"
      color="#07c160"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="onConfirmDate"
      :default-date="default_date"
      :allow-same-day="true"
    />
  </div>
</template>

<script>
import { sale_list } from "@/api/work/manage/sale.js";
import {
  timestampToDate,
  timestampToDateNewDate,
  timestampToTime,
  longtimestampToDate,
} from "@/utils/timestamp";
import {
  weightUnit,
  weightUnitChange,
  moneyUnit,
  unitChange,
} from "@/utils/saleFilter.js";
export default {
  name: "saleManage",
  filters: {
    toTime(t) {
      return timestampToTime(t);
    },
    toDate(t) {
      return timestampToDateNewDate(t);
    },
  },
  data() {
    return {
      active: 1,
      listQuery: {
        s_time: "",
        e_time: "",
        type: "",
      },
      showCalendar: false, // 日期选择时间
      minDate: new Date("2010/01/01"),
      maxDate: new Date(),
      default_date: [
        new Date(),
        new Date(timestampToDateNewDate(new Date().getTime() / 1000 - 1)),
      ],
      xs_real: 0, //销售实收
      repayment_sum: 0, //赊欠
      paid_amount: 0, //总收入
      discount: 0, //优惠金额
      paid_count: 0, //销售单数
      goods: [], //商品列表
      batch: [], //批次列表
      infoTip: "正在加载中",
      searchGoodsName: "",
      searchTime_star: 0,
      searchTime_end: 0,
      isLook: false,
    };
  },
  created() {
    this.listQuery.s_time = timestampToDateNewDate(new Date().getTime() / 1000);
    this.listQuery.e_time = timestampToDateNewDate(new Date().getTime() / 1000);
    this.searchTime_star = Math.floor(
      new Date(this.listQuery.s_time).getTime() / 1000
    );
    this.searchTime_end = Math.floor(
      new Date(this.listQuery.e_time).getTime() / 1000 + 86400 - 1
    );
    this.getList();
  },
  mounted() {},
  filters: {
    weightUnit,
    weightUnitChange,
    moneyUnit,
    unitChange,
    moneyAddDot(money) {
      return (money + "")
        .split("")
        .reverse()
        .join("")
        .replace(/(\d{3})(?=\d)/g, "$1,")
        .split("")
        .reverse()
        .join("");
    },
    toDate(t) {
      return timestampToDate(t);
    },
    toTime(t) {
      return timestampToTime(t);
    },
    numToFixed(obj) {
      if (obj.weight != 0) {
        return (parseFloat(obj.payment) / parseFloat(obj.weight)).toFixed(2);
      } else {
        return (parseFloat(obj.payment) / parseFloat(obj.num)).toFixed(2);
      }
    },
  },
  methods: {
    resetTime() {
      this.listQuery.s_time = timestampToDateNewDate(
        new Date().getTime() / 1000
      );
      this.listQuery.e_time = timestampToDateNewDate(
        new Date().getTime() / 1000
      );
      this.searchTime_star = Math.floor(
        new Date(this.listQuery.s_time).getTime() / 1000
      );
      this.searchTime_end = Math.floor(
        new Date(this.listQuery.e_time).getTime() / 1000 + 86400 - 1
      );
      this.default_date = [
        new Date(),
        new Date(timestampToDateNewDate(new Date().getTime() / 1000 - 1)),
      ];
      this.getList();
    },
    //清空搜索
    clearSearchName() {
      this.searchGoodsName = "";
      this.getList();
    },
    jumpGoodsDetail(name, type) {
      if (type != 2) {
        //进入批次页面
        this.$router.push({
          path: "/manage/sale/saleGoodsDetail",
          query: {
            saleType: this.active,
            name,
            time_star: this.searchTime_star,
            time_end: this.searchTime_end,
          },
        });
      }
    },
    switchType(name) {
      this.active = name;
      this.searchGoodsName = "";
      this.getList();
    },
    jumpBatchDetail(
      batch_id,
      supplier_sn,
      goods_total_price,
      create_time,
      type,
      supplier_name,
      batch
    ) {
      this.$router.push({
        path: "/manage/sale/saleBatchDetail",
        query: {
          saleType: this.active,
          batch_id,
          supplier_sn,
          goods_total_price,
          create_time,
          type,
          supplier_name,
          time_star: this.searchTime_star,
          time_end: this.searchTime_end,
          batch
        },
      });
    },
    getList() {
      let obj = {
        s_time: this.searchTime_star,
        e_time: this.searchTime_end,
        name: this.searchGoodsName,
        type: this.active,
      };

      sale_list(obj).then((res) => {
        if (res.code == 200) {
          this.xs_real = res.data.xs_real || 0;
          this.repayment_sum = res.data.repayment_sum || 0;
          this.paid_amount = res.data.paid_amount || 0;
          this.discount = res.data.discount || 0;
          this.paid_count = res.data.num || 0;
          if (this.active == 1) {
            if (!res.data.goods || res.data.goods.length === 0) {
              this.goods = [];
              this.infoTip = "暂无";
            }
            this.goods = res.data.goods;
          } else {
            if (!res.data.batch || res.data.batch.length == 0) {
              this.batch = [];
              this.infoTip = "暂无";
            }
            this.batch = res.data.goods;
          }
        }
      });
    },
    onConfirmDate(date) {
      this.listQuery.s_time = timestampToDateNewDate(
        new Date(date[0]).getTime() / 1000
      );
      this.listQuery.e_time = timestampToDateNewDate(
        new Date(date[1]).getTime() / 1000
      );
      this.searchTime_star = Math.floor(
        new Date(this.listQuery.s_time).getTime() / 1000
      );
      this.searchTime_end = Math.floor(
        new Date(this.listQuery.e_time).getTime() / 1000 + 86400 - 1
      );
      this.getList();
      this.showCalendar = false;
    },
    switchStatus(name) {
      if (name == 0) {
        this.isLook = false;
        //今天
        this.listQuery.s_time = timestampToDateNewDate(
          new Date().getTime() / 1000
        );
        this.listQuery.e_time = timestampToDateNewDate(
          new Date().getTime() / 1000
        );
        this.searchTime_star = Math.floor(
          new Date(this.listQuery.s_time).getTime() / 1000
        );
        this.searchTime_end = Math.floor(
          new Date(this.listQuery.e_time).getTime() / 1000 + 86400 - 1
        );
        this.getList();
      } else if (name == 1) {
        this.isLook = false;
        //本周
        let date = new Date();
        let oneWeekBeforeDate = new Date(
          date.getTime() / 1000 - 6 * 24 * 60 * 60
        );
        this.listQuery.s_time = timestampToDateNewDate(oneWeekBeforeDate);
        this.listQuery.e_time = timestampToDateNewDate(
          new Date().getTime() / 1000
        );
        this.searchTime_star = Math.floor(
          new Date(this.listQuery.s_time).getTime() / 1000
        );
        this.searchTime_end = Math.floor(
          new Date(this.listQuery.e_time).getTime() / 1000 + 86400 - 1
        );
        this.getList();
      } else if (name == 2) {
        this.isLook = false;
        //本月
        let nowData = new Date().getDate();
        let nowMonthBeforeDate = new Date(
          new Date().getTime() / 1000 - (nowData - 1) * 24 * 60 * 60
        );
        this.listQuery.s_time = timestampToDateNewDate(nowMonthBeforeDate);
        this.listQuery.e_time = timestampToDateNewDate(
          new Date().getTime() / 1000
        );
        this.searchTime_star = Math.floor(
          new Date(this.listQuery.s_time).getTime() / 1000
        );
        this.searchTime_end = Math.floor(
          new Date(this.listQuery.e_time).getTime() / 1000 + 86400 - 1
        );
        this.getList();
      } else if (name == 3) {
        //自定义
        this.showCalendar = true;
        this.isLook = true;
      }
    },
    //点击搜索
    getSearchGoodsName() {
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.saleManage {
  .dealTime {
    background: #fff;
    padding: 0.22rem 0.2rem;
    margin-bottom: 0.2rem;
  }
  .allSales {
    padding: 0 0.3rem;
    margin-bottom: 0.2rem;
    .pTop {
      width: 100%;
      height: 1.84rem;
      background: url("../../../../assets/img/work/manage/saleManageTotal_bg.png")
        no-repeat;
      background-size: 100% 100%;
      color: #fff;
      text-align: center;
      > div:nth-of-type(1) {
        font-size: 0.28rem;
        padding-top: 0.26rem;
        margin-bottom: 0.2rem;
      }
      > div:nth-of-type(2) {
        span:nth-of-type(1) {
          font-size: 0.32rem;
          font-weight: bold;
          margin-bottom: 0.2rem;
        }
        span:nth-of-type(2) {
          font-size: 0.4rem;
          font-weight: bold;
        }
      }
      > div:nth-of-type(3) {
        font-size: 0.24rem;
        padding-bottom: 0.1rem;
      }
    }
    .pBottom {
      display: flex;
      justify-content: space-between;
      padding: 0.22rem 1rem;

      background: #fff;
      align-items: center;
      text-align: center;
      > div {
        > div:nth-of-type(1) {
          color: #333333;
          margin-bottom: 0.1rem;
          span:nth-of-type(1) {
            font-size: 0.32rem;
          }
          span:nth-of-type(2) {
            font-size: 0.36rem;
          }
        }
        > div:nth-of-type(2) {
          color: #999999;
        }
      }
      > div:nth-of-type(2) {
        width: 0.01rem;
        height: 0.48rem;
        background: #e5e5e5;
      }
    }
    // .allAmount {
    //   margin-left: 0.05rem;
    //   display: flex;
    //   justify-content: space-between;
    //   margin-bottom: 0.29rem;
    //   > span:nth-of-type(1) {
    //     color: #333333;
    //     font-size: 0.4rem;
    //     font-weight: bold;
    //   }
    //   > span:nth-of-type(2) {
    //     color: #f3a427;
    //     font-size: 0.4rem;
    //     font-weight: bold;
    //   }
    // }
    // .realAmount {
    //   margin-left: 0.6rem;
    //   display: flex;
    //   justify-content: space-between;
    //   margin-bottom: 0.3rem;
    //   > span:nth-of-type(1) {
    //     color: #333333;
    //     font-size: 0.36rem;
    //     font-weight: Medium;
    //   }
    //   > span:nth-of-type(2) {
    //     color: #333333;
    //     font-size: 0.36rem;
    //     font-weight: Medium;
    //   }
    // }
    // .creditAmount {
    //   margin-left: 0.6rem;
    //   display: flex;
    //   justify-content: space-between;
    //   margin-bottom: 0.38rem;
    //   > span:nth-of-type(1) {
    //     color: #333333;
    //     font-size: 0.36rem;
    //     font-weight: Medium;
    //   }
    //   > span:nth-of-type(2) {
    //     color: #333333;
    //     font-size: 0.36rem;
    //     font-weight: Medium;
    //   }
    // }
    // .orderDiscount {
    //   display: flex;
    //   justify-content: flex-end;
    //   color: #999999;
    //   font-size: 0.32rem;
    //   font-weight: Medium;
    // }
  }
  .seachBox {
    display: flex;
    justify-content: space-between;
    background: #fff;
    margin-top: 0.2rem;
    padding-top: 0.2rem;
    padding-bottom: 0.08rem;
    padding-left: 0.2rem;
    .seach {
      width: 7rem;
      height: 0.8rem;
      border: 0.01rem solid #cccccc;
      position: relative;
      display: flex;
      align-items: center;
      border-radius: 0.1rem;
      border-right: none;
      img {
        width: 0.26rem;
        height: 0.26rem;
        position: absolute;
        top: 0.28rem;
        left: 0.21rem;
      }
      input {
        background: none;
        height: 0.8rem;
        position: absolute;
        top: 0rem;
        left: 0.47rem;
        padding-left: 0.21rem;
      }
      > div {
        width: 0.3rem;
        height: 0.3rem;
        position: absolute;
        right: 1.2rem;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.02rem;
        color: #fff;
      }
      button {
        border: none;
        outline: none;
        padding: 0;
        background: #31b158;
        position: absolute;
        right: 0;
        top: 0;
        width: 1rem;
        height: 0.8rem;
        color: #fff;
        padding: 0.1rem;
        border-top-right-radius: 0.1rem;
        border-bottom-right-radius: 0.1rem;
      }
    }
    .totalCount {
      color: #666666;
      font-size: 0.32rem;
      display: flex;
      align-items: center;
      span {
        color: #31b158;
      }
    }
  }
  .rankingList {
    background: #fff;
    .tl_box {
      display: flex;
      justify-content: space-between;
      padding: 0.2rem 0rem;
      margin-left: 0.3rem;
      margin-right: 0.2rem;
      color: #333;
      font-size: 0.28rem;
      > div:nth-of-type(1) {
        display: flex;
        align-items: center;
        span:nth-of-type(1) {
          display: block;
          width: 0.06rem;
          height: 0.3rem;
          border-radius: 0.03rem;
          background: #31b158;
          margin-right: 0.1rem;
        }
        span:nth-of-type(2) {
          font-size: 0.32rem;
        }
      }
      > div:nth-of-type(2) {
        font-size: 0.28rem;
        span {
          color: #31b158;
        }
      }
    }
    .line {
      width: 100%;
      height: 0.01rem;
      background: #e5e5e5;
    }
    .listTitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.9rem;
      span {
        color: #333333;
        font-size: 0.32rem;
        font-weight: Medium;
      }
    }
    .listBox {
      padding-left:0.3rem;
      padding-right: 0.2rem;
      .list {
        .goodsName {
          display: flex;
          justify-content: space-between;
          padding-top: 0.12rem;
          div:nth-of-type(1) {
            font-weight: bold;
            font-size: 0.3rem;
          }
        }
        .listData {
          width: 100%;
          padding-bottom: 0.12rem;
          display: flex;
          justify-content: space-between;
          div {
            display: flex;
            flex-direction: column;
            width: 30%;
            div:nth-of-type(1) {
              width: 100%;
              height: 0.8rem;
              display: flex;
              flex-direction: column;
              justify-content: center;
              color: #333;
              font-size: 0.28rem;
              align-items: center;
            }
            div:nth-of-type(2) {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.22rem;
              color: #666;
            }
            div:nth-of-type(3) {
              width: 100%;
              display: flex;
              align-items: flex-end;
              justify-content: center;
              font-size: 0.22rem;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  .select_time {
    width: 100%;
    height: 0.88rem;
    opacity: 0.7;
    overflow: hidden;
    .van-button--default {
      background: #31b158;
      color: #fff;
      width: 1.4rem;
      height: 0.6rem;
      border-radius: 0.2rem;
      padding: 0;
      margin: 0;
      font-size: 0.26rem;
    }
  }
  .top {
    width: 100%;
    height: 3.14rem;
    color: #fff;
    text-align: center;
    overflow: hidden;
    > div:first-child {
      margin-top: 0.23rem;
      margin-bottom: 0.2rem;
    }
    > div:nth-of-type(2) {
      font-size: 0.6rem;
      margin-bottom: 0.1rem;
    }
    > div:last-child {
      font-size: 0.24rem;
    }
  }
  .center {
    width: 6.9rem;
    margin: -0.95rem auto 0.2rem;
    border-radius: 0.16rem;
    background-color: #fff;
    padding-top: 0.42rem;
    padding-bottom: 0.37rem;
    display: flex;
    align-items: center;
    box-shadow: 0 0 0.2rem #dde6ff;
    > div {
      box-sizing: border-box;
      display: inline-block;
      width: 33.3%;
      text-align: center;
      color: #4e4e4e;
      > div:first-child {
        font-size: 0.4rem;
        color: #333333;
      }
      > div:last-child {
        margin-top: 0.2rem;
        color: #999999;
      }
    }
    > div:not(:last-child) {
      border-right: 0.01rem solid #e6e6e6;
    }
  }
  .search-bar {
    display: flex;
    margin: 0.22rem 0.2rem 0.1rem;
    flex-wrap: wrap;
    font-size: 0.28rem;
    .search-date {
      width: 4rem;
      line-height: 0.4rem;
      border-radius: 0.2rem;
      background-color: #fff;
      color: #666666;
      padding: 0 0.1rem;
      // border: 0.01rem solid #cccccc;
      margin-right: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .search-text {
    color: #999999;
    font-size: 0.24rem;
    margin-bottom: 0.12rem;
    margin-left: 0.28rem;
  }
  .sale-title {
    line-height: 0.71rem;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    border-bottom: 0.01rem solid #f2f2f2;
    font-size: 0.32rem;
    padding-left: 0.3rem;
    padding-right: 0.2rem;
    color: #333333;
    > span:first-of-type::before {
      content: "";
      display: inline-block;
      background-color: #31b158;
      width: 0.06rem;
      height: 0.3rem;
      margin-right: 0.1rem;
      vertical-align: middle;
    }
    > span:last-of-type {
      font-size: 0.28rem;
    }
  }
  .goods {
    .goods-content {
      background-color: #fff;
      border-bottom: 0.01rem solid #f2f2f2;
      overflow: hidden;
      .goods-name {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 0.32rem;
        padding-right: 0.2rem;
        font-size: 0.36rem;
        margin-top: 0.39rem;
      }
      .goods-info {
        padding-top: 0.4rem;
        padding-bottom: 0.3rem;
        display: flex;
        > div {
          width: 33.3%;
          box-sizing: border-box;
          text-align: center;
          > div:first-child {
            font-size: 0.32rem;
            color: #333333;
          }
          > div:last-child {
            font-size: 0.28rem;
            color: #999999;
            margin-top: 0.19rem;
          }
        }
      }
    }
  }
  .empty-tip {
    font-size: 0.36rem;
    padding-top: 0.16rem;
    color: #999;
    text-align: center;
  }
  .tl_box {
    display: flex;
    justify-content: space-between;
    padding: 0.2rem 0rem;
    margin-left: 0.3rem;
    margin-right: 0.2rem;
    color: #333;
    font-size: 0.28rem;
    > div:nth-of-type(1) {
      display: flex;
      align-items: center;
      span:nth-of-type(1) {
        display: block;
        width: 0.06rem;
        height: 0.3rem;
        border-radius: 0.03rem;
        background: #31b158;
        margin-right: 0.1rem;
      }
      span:nth-of-type(2) {
        font-size: 0.32rem;
      }
    }
    > div:nth-of-type(2) {
      font-size: 0.28rem;
      span {
        color: #31b158;
      }
    }
  }
  .pline {
    width: 100%;
    height: 0.01rem;
    background: #e5e5e5;
  }
  // 按批次
  .bathPart {
    background: #fff;

    .batchListBox {
      padding: 0px 20px 0px 30px;
      .batchList {
        border-bottom: 0.01rem solid #e5e5e5;
        padding: 0.3rem 0rem;
        .part1 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0.2rem;
          > div:nth-of-type(1) {
            span:nth-of-type(1) {
              color: #333333;
              font-size: 0.36rem;
              margin-right: 0.2rem;
            }
            span:nth-of-type(2) {
              font-size: 0.28rem;
              color: #333;
              margin-right: 0.22rem;
            }
            span:nth-of-type(3) {
              padding: 0.06rem 0.16rem;
              border-radius: 0.18rem;
            }
          }
          > div:nth-of-type(2) {
            color: #666;
            font-weight: bold;
          }
        }
        .part2 {
          font-size: 0.28rem;
          color: #999;
          margin-bottom: 0.3rem;
        }
        .part3 {
          display: flex;
          justify-content: space-around;
          >div {
            text-align: center;
            width: 50%;
            div:nth-of-type(1) {
              color: #333;
              font-size: 0.32rem;
              margin-bottom: 0.2rem;
            }
            div:nth-of-type(2) {
              color: #999999;
              font-size: 0.28rem;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less" >
.van-tabs__nav--card{
  margin:0
}

</style>